import type { TextProps } from '@mantine/core';
import { Group, Skeleton } from '@mantine/core';

import { Text } from '~/domains/common/components/Text/Text';
import { CurrencyConvertor } from '~/components/utils/formatters';

type WithdrawalSummaryItemProps = {
  label: string;
  value: number;
  isLoading?: boolean;
  sx?: TextProps['sx'];
  c?: TextProps['c'];
  'data-test-id'?: string;
};

export function WithdrawalSummaryItem({
  label,
  isLoading = false,
  value,
  sx,
  c,
  ...props
}: WithdrawalSummaryItemProps) {
  return (
    <Group position="apart">
      <Text sx={sx} c={c}>
        {label}
      </Text>
      <Text sx={sx} c={c}>
        <Skeleton data-test-id={props['data-test-id']} visible={isLoading}>
          {CurrencyConvertor(value, true)}
        </Skeleton>
      </Text>
    </Group>
  );
}
